// src/utils/firebase/saveUserClinicMapping.js
import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp,
  deleteField,
} from "firebase/firestore";
import { firebaseApp } from "../../firebase/firebaseApp";

/**
 * Save clinic/study + subject id for fast lookup.
 *
 * Storage of record remains Cloud Storage JSON; this Firestore doc is a denormalised index.
 *
 * Writes to: user_clinic_mapping/{uid}
 *
 * If values are empty strings / null, fields are deleted.
 */
export async function saveUserClinicMapping(uid, { subjectId, clinicStudyId }) {
  if (!uid) throw new Error("saveUserClinicMapping: uid is required");

  const db = getFirestore(firebaseApp);

  const clean = (v) => {
    if (v === undefined || v === null) return null;
    const s = String(v).trim();
    return s.length ? s : null;
  };

  const sSubject = clean(subjectId);
  const sClinic = clean(clinicStudyId);

  const ref = doc(db, "user_clinic_mapping", uid);
  const payload = {
    updatedAt: serverTimestamp(),
  };
  let hasExplicitFieldUpdate = false;

  if (subjectId !== undefined) {
    payload.subjectId = sSubject ? sSubject : deleteField();
    hasExplicitFieldUpdate = true;
  }

  if (clinicStudyId !== undefined) {
    payload.clinicStudyId = sClinic ? sClinic : deleteField();
    hasExplicitFieldUpdate = true;
  }

  if (!hasExplicitFieldUpdate) return;

  await setDoc(ref, payload, { merge: true });
}
